"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Post } from "@/shared/libs/axios/request";
import { orderKeys } from "@/entities/order";
import type {
  CreatePurchaseOrderRequest,
  PurchaseOrderResponse,
} from "@stocks/shared";

export const useCreateOrder = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: CreatePurchaseOrderRequest) =>
      Post<PurchaseOrderResponse, CreatePurchaseOrderRequest>(
        "/v1/purchase-orders",
        values,
      ),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: [orderKeys.orders] });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "발주 등록에 실패했습니다."),
  });
};
